/**
 * Service: terminals
 */
angular.module('acme.common.service.terminals', [])
.service('TerminalsService', [function() {

    return {

      types: [
        {
          name: 'pos',
          label: 'Point of Sale'
        },
        {
          name: 'kiosk',
          label: 'Kiosk'
        }
      ],

      init: function() {
        return true;
      },

      findType: function(type) {

        var i, ii,
            r = false;
        
        for (i=0,ii=this.types.length;i<ii;i++) {
          if (this.types[i].name === type) {
            r = {
              index: i,
              type: this.types[i]
            };
          }
        }

        return r;

      }

    };

}]);